// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__Eoo2j","colMin":"styles_colMin__1qW7f","colCheckbox":"styles_colCheckbox__20KJY"};